import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { PROCEDURES_PAGES_ROUTES as ROUTES } from './utils'
import { lkPublicationPermissions as Permissions } from '@/helpers/enums/permission-models'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

export { MENU as PROCEDURES_PUBLICATIONS } from './utils'

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'procedures',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        './store'
      )
      registerModule(options)
      const { registerModule: handbookRegisterModule } = await import(
        '@/views/FormsHandbook/store/cache'
      )
      handbookRegisterModule(options)
      next()
    },
    component: {
      name: 'view-procedures-layout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: '',
        name: ROUTES.LIST,
        meta: {
          permission: [
            Permissions.read,
          ],
        },
        component: (): PromiseVue => import(
          './ProceduresList.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => createRoutes(options)

export default createModule
